
import React, { useEffect, useState, useRef } from "react";
import {
    Row,
    Col,
    Form,
    Input,
    Select,
    Button
} from '../../ui/ot'
import { useTranslation } from "react-i18next";

const CheckoutForm = ({
    keyPrefix = "library.backstage.borrow",
    propsForm,
    field,
    formReloadCount = 0,
    onFormFinish = () => { },
    propsOnValuesChange = () => { },
    defaultValue = {}
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const [form_] = Form.useForm();
    const form = propsForm ? propsForm : form_
    const [count, setCount] = useState(0);
    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊

    };
    const onFinish = (values) => {
        onFormFinish({
            ...values,
        });

    };
    const onValuesChange = (value, { name, type }) => {

        let formValues = null;
        formValues = form.getFieldsValue();
    };

    const setFieldValue = (name, value) => {
        form.setValue(name, value);
    };
    const getAnyFormValue = (name, count) => {
        let formValues = null;
        formValues = form.getFieldValue(name);
        return formValues;
    };
    useEffect(() => {
        setDataInitialization();
    }, []);

    useEffect(() => {
        let formValues = null;
        formValues = form.getFieldsValue();
    }, [formReloadCount]);
    useEffect(() => {
        // (propsForm ?? form).setFieldsValue({ ...defaultValue })
        setCount((pre) => pre + 1)
    }, [])

    return (
        <Row>
            <Col span={24}>
                <Form
                    form={form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"

                >
                    <Row>
                        <Col span={24}>
                            <FormItemComponent
                                field={field}
                                // initialValues={initialValues}
                                getAnyFormValue={getAnyFormValue}
                                count={count}
                                setFieldValue={setFieldValue}
                                setCount={setCount}

                            />
                        </Col>
                    </Row>

                </Form >
            </Col >
        </Row >
    );
};
const FormItemComponent = ({
    keyPrefix = "library.backstage.borrow",
    field,
    initialValues = {},
    show,
    getAnyFormValue,
    count,
    setFieldValue,
    setCount
}) => {
    const { t } = useTranslation('translation', { keyPrefix })

    return (
        <>
            <Row>
                <Col span={24}>
                    <Form.Item

                        {...field}
                        name={[field?.name ?? '', 'issue_id']}
                        fieldKey={[field?.fieldKey, 'issue_id']}
                        rules={[
                            {
                                required: true,
                                message: "請輸入",
                            },

                        ]}
                        hidden={true}
                    >
                        <Input
                            hidden={true}
                        />
                    </Form.Item>
                </Col>

                <Col span={24}>
                    <Form.Item
                        {...field}
                        label={t('note')}
                        name={[field?.name ?? '', 'note']}
                        fieldKey={[field?.fieldKey, 'note']}
                        rules={[
                            {
                                required: true,
                                message: "請輸入",
                            },
                        ]}
                    >
                        <Input

                        />
                    </Form.Item>
                </Col>
            </Row>
        </>
    );
};





export default CheckoutForm;
